<template>
  <div id="nsd">
    <div id="mainFixed3" class="mainFixed">
      <div class="pageTop">
        <div>
          <allSelect @on-change="brandChange" :disabled="brandList&&brandList.length>0?false:true" :chooseData="brandList" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" :state="'Status'" v-model="postData.brandCode" :width="'220px'">
          </allSelect>
          <span>&nbsp;&nbsp;{{$t('common.Year')}}：{{$commonJs.getMonthTh(month+0)>$commonJs.getMonthTh(month+3)?year+'~'+(parseInt(year)+1):year}}</span>
        </div>
        <div>{{$t('common.YtdMsg'+$commonJs.getMonthTh(month))}}</div>
      </div>
      <div class="allSearch d_flex">
        <dl>
          <dd>
            <span class="f_w">{{$t('common.TopHospital')}}:</span>
            <div class="dis_line v_m">
              <hospitalSelect :cols="1" @submit="hospitalChange" :disabled="hospitalList&&hospitalList.length>0?false:true" :chooseData="hospitalList" :multiple="true" :needReturn="'Code'" :matchValue="'Name'" :showValue="'{{Name}}'" v-model="postData.types" :width="'100%'">
              </hospitalSelect>
            </div>
          </dd>
        </dl>
        <dl>
          <dt>
            <button v-if="!hideBtn" class="cancelButtonRed" @click="changeData()">{{$t('common.ChangeSummary')}}</button>
            <button v-if="!hideBtn" class="greenButton m_l_10" :disabled="!nsdData.CanSubmit" @click="submitData()"><i class="icon iconfont icon-Shape"></i>{{$t('common.ConfirmApproval')}}</button>
            <button class="redButton m_l_10" :disabled="!nsdData.CanExport" @click="downLoad()"><i class="icon iconfont icon-daochu"></i>{{$t('common.Export')}}</button>
          </dt>
        </dl>
      </div>
      <table style="table-layout: fixed;" id="noScroll" class="allTable" cellspacing="0">
        <thead>
        <tr>
          <th></th>
          <th>RSD</th>
          <th class="topNum"></th>
          <th>{{$t('common.Region')}}</th>
          <th></th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+0)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+1)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+2)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$t('common.'+$commonJs.getMonthTh(month+3)+'M')}}{{$t('common.Forecast')}}</th>
          <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.QuarterTotal')}}*</th>
<!--          <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>-->
          <th>{{$commonJs.getQuarter(month)}}{{$t('common.QuarterTotal')}}</th>
          <th>{{$commonJs.getQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>
<!--          <th>{{$t('common.YTDRate')}}*</th>-->
          <th>{{$t('common.Submitter')}}</th>
          <th>{{$t('common.Action')}}</th>
          <th>{{$t('common.Status')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr style="background-color: #F9F9F9;" class="colorRed f_w" v-if="nsdData">
          <td></td>
          <td>{{nsdData.Title}}</td>
          <td class="topNum"></td>
          <td style="max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" class="c_p" @click="areaEvent('all')">{{nsdData.Area}}</td>
          <td></td>
          <td>{{$commonJs.numFixed(nsdData.CurrentMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.SecondMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.ThirdMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.FourthMonth)}}</td>
          <td>{{$commonJs.numFixed(nsdData.LastQuarter)}}</td>
<!--          <td>{{nsdData.LastQuarterRate==-1?'&#45;&#45;':Math.round(nsdData.LastQuarterRate*1000)/10+'%'}}{{'('+(nsdData.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(nsdData.LastQuarterOnQuarterRatio*100)+'%)')}}</td>-->
          <td>{{$commonJs.numFixed(nsdData.CurrentQuarter)}}</td>
          <td>{{nsdData.CurrentQuarterRate==-1?'--':Math.round(nsdData.CurrentQuarterRate*1000)/10+'%'}}{{'('+(nsdData.QuarterOnQuraterRatio==-1?'--)':Math.round(nsdData.QuarterOnQuraterRatio*100)+'%)')}}</td>
<!--          <td>{{nsdData.YTD==-1?'— —':Math.round(nsdData.YTD*1000)/10+'%'}}</td>-->
          <td>{{nsdData.SubmittedBy?nsdData.SubmittedBy:''}}</td>
          <td></td>
          <td></td>
        </tr>
        <tr v-if="nsdData&&postData.hospital!=''" style="background-color: #F9F9F9;" class="colorRed f_w">
          <td></td>
          <td>{{$t('common.TopHospital')}}{{$t('common.QuarterTotal')}}</td>
          <td class="topNum"></td>
          <td style="max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{showTopHospital}}</td><!-- class="c_p" @click="areaEvent('all')"-->
          <td></td>
          <td>{{$commonJs.numFixed(nsdData.CurrentMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.SecondMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.ThirdMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.FourthMonthByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.LastQuarterByHospitalTypes)}}</td>
          <td>{{$commonJs.numFixed(nsdData.CurrentQuarterByHospitalTypes)}}</td>
          <td>{{nsdData.CurrentQuarterRateByHospitalTypes==-1?'--':Math.round(nsdData.CurrentQuarterRateByHospitalTypes*1000)/10+'%'}}{{'('+(nsdData.QuarterOnQuraterRatioByHospitalTypes==-1?'--)':Math.round(nsdData.QuarterOnQuraterRatioByHospitalTypes*100)+'%)')}}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="mainScroll" :style="(showChartFlag?'margin-bottom: 288px;':'margin-bottom: 118px;')+'padding-top:'+mainScrollTop+'px'">
      <table style="table-layout: fixed;" class="allTable" cellspacing="0">
        <tbody :key="index" v-for="(item, index) in nsdData.ChildrenList" v-if="nsdData.ChildrenList&&nsdData.ChildrenList.length > 0">
          <tr>
            <td :class="item.Expendable?'expend_able':'expend_disable'" @click="item.Expendable?expendRow(item.TerritoryCode,index):''">{{postData.hospital==''?(expendRowCode == item.TerritoryCode?$t('common.PackUp')+'>':$t('common.Expand')):''}}</td>
            <td>{{item.Title}}</td>
            <td class="topNum">{{item.Type}}</td>
            <td>
              <span @click="postData.hospital==''?areaEvent(item):hospitalEvent(item)" :class="postData.hospital==''?'c_p':'greenA c_p'">{{item.Area}}</span>
            </td>
            <td><tsName :value="item.EmployeeNames"></tsName></td>
            <td v-if="item.Visible" class="salesBorder" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedCurrentMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.CurrentMonth" v-model="item.CurrentMonth"></editCom>
                  <i v-if="postData.hospital!='' && $commonJs.isShowHigh(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="postData.hospital!='' && $commonJs.isShowLow(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.CurrentMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)?'colorGreen':($commonJs.isShowLow(item.LastMonthMinuTwoSalesAmount,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.CurrentMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.CurrentMonth"><showReason v-model="item.Reasons.CurrentMonth"></showReason></div>
            </td>
            <td v-else class="salesBorder">— —</td>
            <td v-if="item.Visible" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedSecondMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.SecondMonth" v-model="item.SecondMonth"></editCom>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowHigh(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowLow(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.SecondMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.LastMonthMinuOneSalesAmount,item.LastMonthSalesAmount,item.SecondMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.SecondMonth"><showReason v-model="item.Reasons.SecondMonth"></showReason></div>
            </td>
            <td v-else>— —</td>
            <td v-if="item.Visible" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedThirdMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.ThirdMonth" v-model="item.ThirdMonth"></editCom>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="postData.hospital!=''&& $commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.ThirdMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.LastMonthSalesAmount,item.ThirdMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.ThirdMonth"><showReason v-model="item.Reasons.ThirdMonth"></showReason></div>
            </td>
            <td v-else>— —</td>
            <td v-if="item.Visible" :class="item.canEdit?'editBC':''">
              <div :class="item.IsModifiedFourthMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                <div style="display: flex;align-items: center;">
                  <editCom :canEdit="item.canEdit" :value="item.FourthMonth" v-model="item.FourthMonth"></editCom>
                  <i v-if="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)" class="icon iconfont icon-wanjiantou-"></i>
                  <i v-if="$commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)" class="icon iconfont icon-wanjiantou"></i>
                </div>
                <reason v-if="item.Reasons" v-model="item.Reasons.FourthMonth" :canEdit="item.canEdit" @changeValue="changeReason"></reason>
              </div>
              <div :class="$commonJs.isShowHigh(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)?'colorGreen':($commonJs.isShowLow(item.CurrentMonth,item.SecondMonth,item.ThirdMonth,item.FourthMonth)?'colorRed':'')"
                   v-if="item.Reasons&&item.Reasons.FourthMonth"><showReason v-model="item.Reasons.FourthMonth"></showReason></div>
            </td>
            <td v-else>— —</td>
            <td v-if="item.Visible">{{$commonJs.numFixed(item.LastQuarter)}}</td>
            <td v-else>— —</td>
<!--              <td v-if="item.Visible">-->
<!--                {{item.LastQuarterRate==-1?'&#45;&#45;':Math.round(item.LastQuarterRate*1000)/10+'%'}}-->
<!--                {{'('+(item.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(item.LastQuarterOnQuarterRatio*100)+'%)')}}-->
<!--              </td>-->
<!--              <td v-else>— —</td>-->
            <td v-if="item.Visible">{{$commonJs.numFixed(item.CurrentQuarter)}}</td>
            <td v-else>— —</td>
            <td v-if="item.Visible">
              {{item.CurrentQuarterRate==-1?'--':Math.round(item.CurrentQuarterRate*1000)/10+'%'}}
              {{'('+(item.QuarterOnQuraterRatio==-1?'--)':Math.round(item.QuarterOnQuraterRatio*100)+'%)')}}
            </td>
            <td v-else>— —</td>
<!--              <td v-if="item.Visible">{{item.YTD==-1?'— —':Math.round(item.YTD*1000)/10+'%'}}</td>-->
<!--              <td v-else>— —</td>-->
            <td>{{item.SubmittedBy?item.SubmittedBy:''}}</td>
            <td>
              <i v-if="!hideBtn&&item.Status==$t('common.PendingApproval')" @click="rejectEvent(item.TerritoryCode)" class="icon iconfont icon-guanbi1 colorRed"> {{$t('common.Return')}}</i>
              <showReason v-if="item.Status==$t('common.Draft')&&item.RejectInfo" v-model="item.rejectObj"></showReason>
            </td>
            <td>{{postData.hospital==''&&!hideBtn?item.DisplayStatus:''}}</td>
          </tr>
          <tr>
            <td colspan="15" style="padding: 0">
              <table style="table-layout: fixed;" class="allTable" cellspacing="0" v-if="expendRowCode==item.TerritoryCode" :key="k" v-for="(sItem, k) in item.child">
                <tr style="background-color: #F8F8F8;">
                  <td style="padding-left: 20px" :class="sItem.Expendable?'expend_able':'expend_disable'" @click="sItem.Expendable?expendSubRow(sItem.TerritoryCode,index,k):''">{{postData.hospital==''?(expendSubRowCode == sItem.TerritoryCode?$t('common.PackUp')+'>':$t('common.Expand')):''}}</td>
                  <td>{{sItem.Title}}</td>
                  <td class="topNum">{{sItem.Type}}</td>
                  <td>
                    <span @click="postData.hospital==''?areaEvent(sItem):hospitalEvent(sItem)" :class="postData.hospital==''?'c_p':'greenA c_p'">{{sItem.Area}}</span>
                  </td>
                  <td><tsName :value="sItem.EmployeeNames"></tsName></td>
                  <td class="salesBorder" :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.CurrentMonth" v-model="sItem.CurrentMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.CurrentMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.SecondMonth" v-model="sItem.SecondMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.SecondMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.ThirdMonth" v-model="sItem.ThirdMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.ThirdMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td :class="sItem.canEdit?'editBC':''">
                    <div style="display: flex;justify-content: space-between;align-sitems: center;">
                      <div style="display: flex;align-sitems: center;">
                        <editCom :canEdit="sItem.canEdit" :value="sItem.FourthMonth" v-model="sItem.FourthMonth"></editCom>
                      </div>
                      <reason v-if="sItem.Reasons" v-model="sItem.Reasons.FourthMonth" :canEdit="sItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                  </td>
                  <td>{{$commonJs.numFixed(sItem.LastQuarter)}}</td>
      <!--                <td>-->
      <!--                  {{sItem.LastQuarterRate==-1?'&#45;&#45;':Math.round(sItem.LastQuarterRate*1000)/10+'%'}}-->
      <!--                  {{'('+(sItem.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(sItem.LastQuarterOnQuarterRatio*100)+'%)')}}-->
      <!--                </td>-->
                  <td>{{$commonJs.numFixed(sItem.CurrentQuarter)}}</td>
                  <td>
                    {{sItem.CurrentQuarterRate==-1?'--':Math.round(sItem.CurrentQuarterRate*1000)/10+'%'}}
                    {{'('+(sItem.QuarterOnQuraterRatio==-1?'--)':Math.round(sItem.QuarterOnQuraterRatio*100)+'%)')}}
                  </td>
      <!--                <td>{{sItem.YTD==-1?'— —':Math.round(sItem.YTD*1000)/10+'%'}}</td>-->
                  <td>{{sItem.SubmittedBy?sItem.SubmittedBy:''}}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr v-if="expendSubRowCode==sItem.TerritoryCode" :key="j" v-for="(subItem, j) in sItem.child">
                  <td></td>
                  <td>{{subItem.Title}}</td>
                  <td class="topNum">{{subItem.Type}}</td>
                  <td>
                    <span @click="hospitalEvent(subItem)" class="greenA c_p">{{subItem.Area}}</span>
                  </td>
                  <td><tsName :value="subItem.EmployeeNames"></tsName></td>
                  <td class="salesBorder" :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedCurrentMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.CurrentMonth" v-model="subItem.CurrentMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.CurrentMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)?'colorGreen':($commonJs.isShowLow(subItem.LastMonthMinuTwoSalesAmount,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.CurrentMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.CurrentMonth"><showReason v-model="subItem.Reasons.CurrentMonth"></showReason></div>
                  </td>
                  <td :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedSecondMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.SecondMonth" v-model="subItem.SecondMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.SecondMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)?'colorGreen':($commonJs.isShowLow(subItem.CurrentMonth,subItem.LastMonthMinuOneSalesAmount,subItem.LastMonthSalesAmount,subItem.SecondMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.SecondMonth"><showReason v-model="subItem.Reasons.SecondMonth"></showReason></div>
                  </td>
                  <td :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedThirdMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.ThirdMonth" v-model="subItem.ThirdMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.ThirdMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)?'colorGreen':($commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.LastMonthSalesAmount,subItem.ThirdMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.ThirdMonth"><showReason v-model="subItem.Reasons.ThirdMonth"></showReason></div>
                  </td>
                  <td :class="subItem.canEdit?'editBC':''">
                    <div :class="subItem.IsModifiedFourthMonth?'bgRed':''" style="display: flex;justify-content: space-between;align-items: center;">
                      <div style="display: flex;align-items: center;">
                        <editCom :canEdit="subItem.canEdit" :value="subItem.FourthMonth" v-model="subItem.FourthMonth"></editCom>
                        <i v-if="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)" class="icon iconfont icon-wanjiantou-"></i>
                        <i v-if="$commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)" class="icon iconfont icon-wanjiantou"></i>
                      </div>
                      <reason v-if="subItem.Reasons" v-model="subItem.Reasons.FourthMonth" :canEdit="subItem.canEdit" @changeValue="changeReason"></reason>
                    </div>
                    <div :class="$commonJs.isShowHigh(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)?'colorGreen':($commonJs.isShowLow(subItem.CurrentMonth,subItem.SecondMonth,subItem.ThirdMonth,subItem.FourthMonth)?'colorRed':'')"
                         v-if="subItem.Reasons&&subItem.Reasons.FourthMonth"><showReason v-model="subItem.Reasons.FourthMonth"></showReason></div>
                  </td>
                  <td>{{$commonJs.numFixed(subItem.LastQuarter)}}</td>
      <!--                <td>-->
      <!--                  {{subItem.LastQuarterRate==-1?'&#45;&#45;':Math.round(subItem.LastQuarterRate*1000)/10+'%'}}-->
      <!--                  {{'('+(subItem.LastQuarterOnQuarterRatio==-1?'&#45;&#45;)':Math.round(subItem.LastQuarterOnQuarterRatio*100)+'%)')}}-->
      <!--                </td>-->
                  <td>{{$commonJs.numFixed(subItem.CurrentQuarter)}}</td>
                  <td>
                    {{subItem.CurrentQuarterRate==-1?'--':Math.round(subItem.CurrentQuarterRate*1000)/10+'%'}}
                    {{'('+(subItem.QuarterOnQuraterRatio==-1?'--)':Math.round(subItem.QuarterOnQuraterRatio*100)+'%)')}}
                  </td>
      <!--                <td>{{subItem.YTD==-1?'— —':Math.round(subItem.YTD*1000)/10+'%'}}</td>-->
                  <td>{{subItem.SubmittedBy?subItem.SubmittedBy:''}}</td>
                  <td></td>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
        </tbody>
        <tbody v-if="!nsdData.ChildrenList||nsdData.ChildrenList.length == 0">
          <tr>
            <td colspan="10" class="t_c colorGray bot_bottom">{{$t('common.noData')}}</td>
          </tr>
        </tbody>
      </table>
      <page v-if="postData.hospital!=''&&nsdData.ChildrenList&&nsdData.ChildrenList.length>0" :totalPage="Math.ceil(nsdData.Total/pageSize)" :page="pageIndex" @on-getList="changePage"></page>
    </div>
    <div style="position: relative;height: 1px;"></div>
    <div class="chartArea" :class="showChartFlag?'show':'hide'">
      <button class="chartButton" @click="showChart()">{{showChartFlag?$t('common.Hide'):$t('common.Expand')}}</button>
      <div id="Charts"></div>
    </div>
    <dialogArea :show="showDialog" :width="'80%'" @cancel="submitCancel" @confirm="submitConfirm" :title="$t('common.Preview')">
      <div slot="content">
        <div style="margin-top:-10px;margin-bottom: 15px;">
          <span style="margin-right: 20px">{{$t('common.Brand')}}：{{this.brandName}}</span><span>{{$t('common.Region')}}：{{nsdPreviewData.Area}}</span>
        </div>
        <table class="dialogTable" cellspacing="0">
          <thead>
          <tr>
            <th>RSD</th>
            <th>{{$t('common.Region')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+0)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+1)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+2)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$t('common.'+$commonJs.getMonthTh(month+3)+'M')}}{{$t('common.Forecast')}}</th>
            <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.QuarterTotal')}}*</th>
<!--            <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>-->
            <th>{{$commonJs.getQuarter(month)}}{{$t('common.QuarterTotal')}}</th>
            <th>{{$commonJs.getQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>
<!--            <th>{{$t('common.YTDRate')}}*</th>-->
          </tr>
          </thead>
          <tbody>
          <tr class="f_w">
            <td>{{nsdPreviewData.Title}}</td>
            <td style="max-width: 200px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{nsdPreviewData.Area}}</td>
            <td>{{$commonJs.numFixed(nsdPreviewData.CurrentMonth)}}</td>
            <td>{{$commonJs.numFixed(nsdPreviewData.SecondMonth)}}</td>
            <td>{{$commonJs.numFixed(nsdPreviewData.ThirdMonth)}}</td>
            <td>{{$commonJs.numFixed(nsdPreviewData.FourthMonth)}}</td>
            <td>{{$commonJs.numFixed(nsdPreviewData.LastQuarter)}}</td>
<!--            <td>-->
<!--              <span v-if="nsdPreviewData.LastQuarterRate==-1">&#45;&#45;</span>-->
<!--              <span v-else :class="nsdPreviewData.LastQuarterRate<1?'colorYellow':''">{{Math.round(nsdPreviewData.LastQuarterRate*1000)/10}}%</span>-->
<!--              <span v-if="nsdPreviewData.LastQuarterOnQuarterRatio==-1">(&#45;&#45;)</span>-->
<!--              <span v-else :class="nsdPreviewData.LastQuarterOnQuarterRatio<0?'colorYellow':''">({{Math.round(nsdPreviewData.LastQuarterOnQuarterRatio*100)}}%)</span>-->
<!--            </td>-->
            <td>{{$commonJs.numFixed(nsdPreviewData.CurrentQuarter)}}</td>
            <td>
              <span v-if="nsdPreviewData.CurrentQuarterRate==-1">--</span>
              <span v-else :class="nsdPreviewData.CurrentQuarterRate<1?'colorYellow':''">{{Math.round(nsdPreviewData.CurrentQuarterRate*1000)/10}}%</span>
              <span v-if="nsdPreviewData.QuarterOnQuraterRatio==-1">(--)</span>
              <span v-else :class="nsdPreviewData.QuarterOnQuraterRatio<0?'colorYellow':''">({{Math.round(nsdPreviewData.QuarterOnQuraterRatio*100)}}%)</span>
            </td>
<!--            <td>{{nsdPreviewData.YTD==-1?'— —':Math.round(nsdPreviewData.YTD*1000)/10+'%'}}</td>-->
          </tr>
          <tr :key="index" v-for="(item, index) in nsdPreviewData.ChildrenList" v-if="nsdPreviewData.ChildrenList&&nsdPreviewData.ChildrenList.length > 0">
            <td>{{item.Title}}</td>
            <td>{{item.Area}}</td>
            <td>{{$commonJs.numFixed(item.CurrentMonth)}}</td>
            <td>{{$commonJs.numFixed(item.SecondMonth)}}</td>
            <td>{{$commonJs.numFixed(item.ThirdMonth)}}</td>
            <td>{{$commonJs.numFixed(item.FourthMonth)}}</td>
            <td>{{$commonJs.numFixed(item.LastQuarter)}}</td>
<!--            <td>-->
<!--              <span v-if="item.LastQuarterRate==-1">&#45;&#45;</span>-->
<!--              <span v-else :class="item.LastQuarterRate<1?'colorYellow':''">{{Math.round(item.LastQuarterRate*1000)/10}}%</span>-->
<!--              <span v-if="item.LastQuarterOnQuarterRatio==-1">(&#45;&#45;)</span>-->
<!--              <span v-else :class="item.LastQuarterOnQuarterRatio<0?'colorYellow':''">({{Math.round(item.LastQuarterOnQuarterRatio*100)}}%)</span>-->
<!--            </td>-->
            <td>{{$commonJs.numFixed(item.CurrentQuarter)}}</td>
            <td>
              <span v-if="item.CurrentQuarterRate==-1">--</span>
              <span v-else :class="item.CurrentQuarterRate<1?'colorYellow':''">{{Math.round(item.CurrentQuarterRate*1000)/10}}%</span>
              <span v-if="item.QuarterOnQuraterRatio==-1">(--)</span>
              <span v-else :class="item.QuarterOnQuraterRatio<0?'colorYellow':''">({{Math.round(item.QuarterOnQuraterRatio*100)}}%)</span>
            </td>
<!--            <td>{{item.YTD==-1?'— —':Math.round(item.YTD*1000)/10+'%'}}</td>-->
          </tr>
          </tbody>
        </table>
      </div>
    </dialogArea>
    <dialogArea :show="showChangeDialog" :width="'80%'" @cancel="changeCancel" :title="$t('common.ChangeSummary')">
      <div slot="content">
        <div :key="index" v-for="(item, index) in changeNsdData" v-if="changeNsdData&&changeNsdData.length > 0" style="padding:10px;margin-bottom: 20px;box-shadow: 0px 5px 5px 0px #ccc;">
          <div v-if="item.RejectInfo" style="margin-top:5px;margin-bottom: 15px;padding-left: 30px;">{{item.RejectInfo}}</div>
          <table class="dialogTable" cellspacing="0">
            <thead>
            <tr>
              <th style="border: none;width: 10px;"></th>
              <th>RSD</th>
              <th>{{$t('common.Region')}}</th>
              <th>{{$t('common.'+$commonJs.getMonthTh(month+0)+'M')}}{{$t('common.Forecast')}}</th>
              <th>{{$t('common.'+$commonJs.getMonthTh(month+1)+'M')}}{{$t('common.Forecast')}}</th>
              <th>{{$t('common.'+$commonJs.getMonthTh(month+2)+'M')}}{{$t('common.Forecast')}}</th>
              <th>{{$t('common.'+$commonJs.getMonthTh(month+3)+'M')}}{{$t('common.Forecast')}}</th>
              <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.QuarterTotal')}}*</th>
<!--              <th>{{$commonJs.getLastQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>-->
              <th>{{$commonJs.getQuarter(month)}}{{$t('common.QuarterTotal')}}</th>
              <th>{{$commonJs.getQuarter(month)}}{{$t('common.RateAndQoQ')}}</th>
<!--              <th>{{$t('common.YTDRate')}}*</th>-->
            </tr>
            </thead>
            <tbody>
            <tr style="background-color: white">
              <td class="colorRed f_w" style="border: none;text-align: right;padding:0 2px 0 0;">New</td>
              <td>{{item.RSDName}}</td>
              <td>{{item.RSDTerritoryName}}</td>
              <td :class="item.IsModifiedCurrentMonth?'bgRed':''">{{$commonJs.numFixed(item.CurrentMonthNew)}}</td>
              <td :class="item.IsModifiedSecondMonth?'bgRed':''">{{$commonJs.numFixed(item.SecondMonthNew)}}</td>
              <td :class="item.IsModifiedThirdMonth?'bgRed':''">{{$commonJs.numFixed(item.ThirdMonthNew)}}</td>
              <td :class="item.IsModifiedFourthMonth?'bgRed':''">{{$commonJs.numFixed(item.FourthMonthNew)}}</td>
              <td>{{$commonJs.numFixed(item.LastQuarter)}}</td>
<!--              <td>-->
<!--                <span v-if="item.LastQuarterRate==-1">&#45;&#45;</span>-->
<!--                <span v-else :class="item.LastQuarterRate<1?'colorYellow':''">{{Math.round(item.LastQuarterRate*1000)/10}}%</span>-->
<!--                <span v-if="item.LastQuarterOnQuarterRatio==-1">(&#45;&#45;)</span>-->
<!--                <span v-else :class="item.LastQuarterOnQuarterRatio<0?'colorYellow':''">({{Math.round(item.LastQuarterOnQuarterRatio*100)}}%)</span>-->
<!--              </td>-->
              <td>{{$commonJs.numFixed(item.CurrentQuarterNew)}}</td>
              <td>
                <span v-if="item.CurrentQuarterRateNew==-1">--</span>
                <span v-else :class="item.CurrentQuarterRateNew<1?'colorYellow':''">{{Math.round(item.CurrentQuarterRateNew*1000)/10}}%</span>
                <span v-if="item.QuarterOnQuarterRatioNew==-1">(--)</span>
                <span v-else :class="item.QuarterOnQuarterRatioNew<0?'colorYellow':''">({{Math.round(item.QuarterOnQuarterRatioNew*100)}}%)</span>
              </td>
<!--              <td>{{item.YTDNew==-1?'— —':Math.round(item.YTDNew*100)+'%'}}</td>-->
            </tr>
            <tr>
              <td style="border: none;"></td>
              <td>{{item.RSDName}}</td>
              <td>{{item.RSDTerritoryName}}</td>
              <td>{{$commonJs.numFixed(item.CurrentMonth)}}</td>
              <td>{{$commonJs.numFixed(item.SecondMonth)}}</td>
              <td>{{$commonJs.numFixed(item.ThirdMonth)}}</td>
              <td>{{$commonJs.numFixed(item.FourthMonth)}}</td>
              <td>{{$commonJs.numFixed(item.LastQuarter)}}</td>
<!--              <td>-->
<!--                <span v-if="item.LastQuarterRate==-1">&#45;&#45;</span>-->
<!--                <span v-else :class="item.LastQuarterRate<1?'colorYellow':''">{{Math.round(item.LastQuarterRate*1000)/10}}%</span>-->
<!--                <span v-if="item.LastQuarterOnQuarterRatio==-1">(&#45;&#45;)</span>-->
<!--                <span v-else :class="item.LastQuarterOnQuarterRatio<0?'colorYellow':''">({{Math.round(item.LastQuarterOnQuarterRatio*100)}}%)</span>-->
<!--              </td>-->
              <td>{{$commonJs.numFixed(item.CurrentQuarter)}}</td>
              <td>
                <span v-if="item.CurrentQuarterRate==-1">--</span>
                <span v-else :class="item.CurrentQuarterRate<1?'colorYellow':''">{{Math.round(item.CurrentQuarterRate*1000)/10}}%</span>
                <span v-if="item.QuarterOnQuarterRatio==-1">(--)</span>
                <span v-else :class="item.QuarterOnQuarterRatio<0?'colorYellow':''">({{Math.round(item.QuarterOnQuarterRatio*100)}}%)</span>
              </td>
<!--              <td>{{item.YTD==-1?'— —':Math.round(item.YTD*1000)/10+'%'}}</td>-->
            </tr>
            </tbody>
          </table>
        </div>
        <div v-if="!changeNsdData||changeNsdData.length==0" style="text-align: center;">{{$t('common.NoChangeRecord')}}</div>
      </div>
      <div slot="foter"></div>
    </dialogArea>
    <dialogArea :show="showRejectDialog" :width="'45%'" @cancel="rejectCancel" @confirm="rejectConfirm" :title="$t('common.ReturnedOk')">
      <div slot="content">
        <div style="text-align: center;font-size: 16px;margin-bottom: 40px">{{$t('common.ReturnedMsg')}}</div>
        <div style="margin:0 auto;width: 80%;display: flex;">
          <div style="margin-right: 20px;padding: 10px;"><span class="colorRed">*</span>{{$t('common.Comments')}}</div>
          <div style="flex: 1"><textarea style="width: 100%;height: 100px;padding: 10px;resize: none;border: 1px solid #c73343;border-radius: 10px;" maxlength="50" v-model="rejectInfo" :placeholder="$t('common.NsdReturnPlaceHolder')"></textarea></div>
        </div>
      </div>
    </dialogArea>
  </div>
</template>

<script>
// let timePage
export default {
  name: 'nsd',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      height: 0,
      hospitalList: [],
      showTopHospital: '',
      postData: {
        brandCode: '',
        hospital: '',
        hospitalCodes: '',
        asmCode: '',
        role: 'NSD',
        types: ''
      },
      postRejectData: {
        territoryCode: '',
        brandCode: '',
        comment: ''
      },
      showHospitalName: '',
      areaName: this.$t('common.AllTotal'),
      brandList: [],
      brandName: '',
      nsdData: false,
      nsdPreviewData: false,
      chartData: [],
      showChartFlag: true,
      expendRowCode: false,
      expendSubRowCode: false,
      dialogData: false,
      showDialog: false,
      rejectInfo: '',
      showRejectDialog: false,
      showChangeDialog: false,
      changeNsdData: [],
      hideBtn: false,
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      mainScrollTop: 178
    }
  },
  beforeCreate () {
    this.$parent.topName = 'NSD'
  },
  created () {
    this.getBrandList()
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeTable)
  },
  mounted () {
    this.$nextTick(() => {
      this.mainScrollTop = document.getElementById('mainFixed3').offsetHeight
      document.body.scrollTop = document.documentElement.scrollTop = 0
    })
    window.addEventListener('resize', this.resizeTable)
  },
  methods: {
    resizeTable () {
      this.mainScrollTop = document.getElementById('mainFixed3').offsetHeight
      this.$chart.chartResize()
    },
    getBrandList () {
      this.$axiox.get('/api/v1/admin/brand/list').then(msg => {
        this.brandList = msg.data.BrandList || []
        let seltIndex = 0
        if (this.brandList && this.brandList.length > 0) {
          if (localStorage.brandCodeKey && localStorage.brandCodeKey !== '') {
            this.postData.brandCode = localStorage.brandCodeKey
          }
          this.brandList.forEach((e, i) => {
            if (e.Status === this.$t('common.Draft')) {
              this.brandList[i].state = true
            } else {
              this.brandList[i].state = false
            }
            if (this.postData.brandCode === e.Code) {
              seltIndex = i
            }
          })
          this.postData.brandCode = this.brandList[seltIndex].Code
          if (this.postData.brandCode.indexOf('_') !== -1) {
            this.hideBtn = true
          } else {
            this.hideBtn = false
          }
          localStorage.brandCodeKey = this.postData.brandCode
          this.brandName = this.brandList[seltIndex].Name
          this.year = this.brandList[seltIndex].Year
          this.month = this.brandList[seltIndex].Month
          this.getHospitalList()
        }
      })
    },
    getHospitalList () {
      this.postData.hospital = ''
      this.postData.types = ''
      this.hospitalList = []
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/hospital/list', data)
      this.$axiox.get(url).then(msg => {
        this.postData.hospitalCodes = ''
        if (msg.data && msg.data.length > 0) {
          msg.data.unshift({Code: '', Name: this.$i18n.t('common.All')})
          this.hospitalList = msg.data || []
          this.showHospitalName = this.$i18n.t('common.All')
          this.getNsdList()
        }
      })
    },
    changePage (val) {
      this.pageIndex = val
      this.getNsdList(true, true)
    },
    getNsdList (isHospitalChange, isChangePage) {
      if (!isChangePage) {
        this.pageIndex = 1
      } else {
        this.nsdData = false
      }
      let data = JSON.parse(JSON.stringify(this.postData))
      if (this.postData.hospital !== '') {
        data.pageIndex = this.pageIndex
        data.pageSize = this.pageSize
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data && msg.data.ChildrenList) {
          msg.data.ChildrenList.forEach((item, index) => {
            if (item.RejectInfo) {
              msg.data.ChildrenList[index].rejectObj = {ShowReason: this.$t('common.ReturnedComments'), Comment: item.RejectInfo}
            }
            // msg.data.ChildrenList[index].canEdit = false
            if (this.postData.hospital !== '') {
              msg.data.ChildrenList[index].Reasons = {
                CurrentMonth: {ReasonCode: item.CurrentMonthReasonCode, Comment: item.CurrentMonthComment, ShowReason: this.getShowReason(item.CurrentMonthReasonCode)},
                SecondMonth: {ReasonCode: item.SecondMonthReasonCode, Comment: item.SecondMonthComment, ShowReason: this.getShowReason(item.SecondMonthReasonCode)},
                ThirdMonth: {ReasonCode: item.ThirdMonthReasonCode, Comment: item.ThirdMonthComment, ShowReason: this.getShowReason(item.ThirdMonthReasonCode)},
                FourthMonth: {ReasonCode: item.FourthMonthReasonCode, Comment: item.FourthMonthComment, ShowReason: this.getShowReason(item.FourthMonthReasonCode)}
              }
            }
            if (this.expendRowCode === item.TerritoryCode) {
              this.getNsdTsList(item.TerritoryCode, index)
            }
          })
        }
        this.nsdData = msg.data || {}
        this.$nextTick(() => {
          this.mainScrollTop = document.getElementById('mainFixed3').offsetHeight
          document.body.scrollTop = document.documentElement.scrollTop = 0
        })
        if (!isChangePage) {
          this.getChartData(isHospitalChange)
        }
      })
    },
    getNsdPreViewList () {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.hospital = ''
      data.hospitalCodes = ''
      data.asmCode = ''
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/list', data)
      this.$axiox.get(url).then(msg => {
        this.nsdPreviewData = msg.data || {}
        this.showDialog = true
      })
    },
    getNsdTsList (territoryCode, index) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.territoryCode = territoryCode
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/asm/list', data)
      this.$axiox.get(url).then(msg => {
        this.$set(this.nsdData.ChildrenList[index], 'child', msg.data)
      })
    },
    getNsdSubTsList (territoryCode, index, k) {
      let data = JSON.parse(JSON.stringify(this.postData))
      data.territoryCode = territoryCode
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/ts/list', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data && msg.data.length > 0) {
          msg.data.forEach((val, i) => {
            // msg.data[i].canEdit = false
            msg.data[i].Reasons = {
              CurrentMonth: {ReasonCode: val.CurrentMonthReasonCode, Comment: val.CurrentMonthComment, ShowReason: this.getShowReason(val.CurrentMonthReasonCode)},
              SecondMonth: {ReasonCode: val.SecondMonthReasonCode, Comment: val.SecondMonthComment, ShowReason: this.getShowReason(val.SecondMonthReasonCode)},
              ThirdMonth: {ReasonCode: val.ThirdMonthReasonCode, Comment: val.ThirdMonthComment, ShowReason: this.getShowReason(val.ThirdMonthReasonCode)},
              FourthMonth: {ReasonCode: val.FourthMonthReasonCode, Comment: val.FourthMonthComment, ShowReason: this.getShowReason(val.FourthMonthReasonCode)}
            }
          })
        }
        this.$set(this.nsdData.ChildrenList[index].child[k], 'child', msg.data)
      })
    },
    expendRow (territoryCode, index) {
      if (this.expendRowCode && this.expendRowCode === territoryCode) {
        this.expendRowCode = false
      } else {
        this.expendRowCode = territoryCode
        if (!this.nsdData.ChildrenList[index].child) {
          this.getNsdTsList(territoryCode, index)
        }
      }
    },
    expendSubRow (territoryCode, index, k) {
      if (this.expendSubRowCode && this.expendSubRowCode === territoryCode) {
        this.expendSubRowCode = false
      } else {
        this.expendSubRowCode = territoryCode
        if (!this.nsdData.ChildrenList[index].child[k].child) {
          this.getNsdSubTsList(territoryCode, index, k)
        }
      }
    },
    getChartData (isHospitalChange) {
      let data = JSON.parse(JSON.stringify(this.postData))
      if (isHospitalChange) {
        data.hospitalCodes = ''
        // data.hospital = ''
      }
      let url = this.$commonJs.returnQuery('/api/v1/admin/chartdata', data)
      this.$axiox.get(url).then(msg => {
        if (msg.data) {
          let datas = {}
          let monthList = []
          let actualList = []
          let forecastList = []
          let targetList = []
          let completionList = []
          if (msg.data.ActualSalesAndForecastList && msg.data.ActualSalesAndForecastList.length > 0) {
            msg.data.ActualSalesAndForecastList.forEach((a, i) => {
              monthList.push(a.YearMonth)
              if (i < 6) {
                actualList.push(a.Value)
                forecastList.push(null)
              } else {
                actualList.push(null)
                forecastList.push(a.Value)
              }
            })
          }
          if (msg.data.TargetList && msg.data.TargetList.length > 0) {
            msg.data.TargetList.forEach((a, i) => {
              targetList.push(a.Value)
            })
          }
          if (msg.data.CompletionPercentageList && msg.data.CompletionPercentageList.length > 0) {
            msg.data.CompletionPercentageList.forEach(a => {
              if (a.Value != null) {
                completionList.push(Math.round(a.Value * 1000) / 10)
              } else {
                completionList.push(null)
              }
            })
          }
          datas.monthList = monthList
          datas.actualList = actualList
          datas.forecastList = forecastList
          datas.targetList = targetList
          datas.completionList = completionList
          this.chartData = datas
          this.$chart.asmChart('Charts', this.brandName + '-' + this.areaName + '-' + this.showHospitalName, this.chartData)
        }
      })
    },
    submitNsdList () {
      let data = JSON.parse(JSON.stringify(this.postData))
      this.$axiox.put('/api/v1/admin/nsdForecast/approved', data).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.ReviewSuccess'),
          stayTime: 5
        })
        this.nsdData = false
        this.getBrandList()
      })
    },
    rejectNsd () {
      let data = JSON.parse(JSON.stringify(this.postRejectData))
      this.$axiox.put('/api/v1/admin/nsdForecast/reject', data).then(msg => {
        this.expendRowCode = false
        this.expendSubRowCode = false
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.ReturnSuccess'),
          stayTime: 5
        })
        // this.nsdData = false
        this.getNsdList()
      })
    },
    getChangeDataList () {
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/changeData', data)
      this.$axiox.get(url).then(msg => {
        this.changeNsdData = msg.data || {}
        this.showChangeDialog = true
      })
    },
    changeData () {
      this.getChangeDataList()
    },
    changeCancel () {
      this.showChangeDialog = false
    },
    downLoad () {
      let data = JSON.parse(JSON.stringify(this.postData))
      let url = this.$commonJs.returnQuery('/api/v1/admin/nsdForecast/export', data)
      this.$axiox.get(url).then(res => {
        location.href = res.data.FileURL
        this.$commonJs.alertTips({
          type: 'success',
          content: this.$t('common.ExportSuccess'),
          stayTime: 5
        })
      })
    },
    brandChange (data) {
      this.brandName = data.Name
      this.year = data.Year
      this.month = data.Month
      this.nsdData = false
      this.expendRowCode = false
      this.postData.hospital = ''
      this.postData.types = ''
      this.postData.hospitalCodes = ''
      this.showHospitalName = this.$i18n.t('common.All')
      this.postData.asmCode = ''
      this.areaName = this.$t('common.AllTotal')
      localStorage.brandCodeKey = this.postData.brandCode
      if (this.postData.brandCode.indexOf('_') !== -1) {
        this.hideBtn = true
      } else {
        this.hideBtn = false
      }
      this.getHospitalList()
    },
    hospitalChange (data) {
      this.postData.hospital = this.postData.types
      this.showTopHospital = data
      this.showHospitalName = this.$i18n.t('common.All')
      this.nsdData = false
      this.expendRowCode = false
      this.postData.asmCode = ''
      this.areaName = this.$t('common.AllTotal')
      this.postData.hospitalCodes = this.postData.hospital
      this.getNsdList(true)
    },
    changeReason (data) {
      // console.log('2', data)
    },
    areaEvent (data) {
      if (data === 'all') {
        this.postData.asmCode = ''
        this.postData.hospitalCodes = ''
        this.showHospitalName = this.$i18n.t('common.All')
        this.areaName = this.$t('common.AllTotal')
      } else {
        this.postData.asmCode = data.TerritoryCode
        this.postData.hospitalCodes = ''
        this.showHospitalName = this.$i18n.t('common.All')
        this.areaName = data.Area
      }
      this.getChartData()
    },
    hospitalEvent (data) {
      this.postData.asmCode = ''
      this.areaName = this.$t('common.AllTotal')
      this.postData.hospitalCodes = data.HospitalCode
      this.showHospitalName = data.Area
      this.getChartData()
    },
    submitData () {
      this.getNsdPreViewList()
    },
    submitConfirm () {
      this.showDialog = false
      this.submitNsdList()
    },
    submitCancel () {
      this.showDialog = false
    },
    rejectEvent (territoryCode) {
      this.postRejectData.territoryCode = territoryCode
      this.rejectInfo = ''
      this.showRejectDialog = true
    },
    rejectConfirm () {
      if (this.rejectInfo === '' || this.rejectInfo.trim() === '') {
        this.rejectInfo = ''
        this.$commonJs.alertTips({
          type: 'error',
          content: this.$t('common.EmptyContent'),
          stayTime: 5
        })
        return false
      } else {
        this.postRejectData.brandCode = this.postData.brandCode
        this.postRejectData.comment = this.rejectInfo
        this.rejectNsd()
        this.showRejectDialog = false
      }
    },
    rejectCancel () {
      this.showRejectDialog = false
    },
    showChart () {
      if (this.showChartFlag) {
        this.showChartFlag = false
      } else {
        this.showChartFlag = true
      }
    },
    getShowReason (rCode) {
      switch (rCode) {
        case '1':
          return this.$t('common.Reason1')
        case '2':
          return this.$t('common.Reason2')
        case '3':
          return this.$t('common.Reason3')
        case '4':
          return this.$t('common.Reason4')
        case '5':
          return this.$t('common.Reason5')
        case '6':
          return this.$t('common.Reason6')
        case '7':
          return this.$t('common.Reason7')
      }
    }
  }
}
</script>

<style scoped>
  .salesBorder{
    border-left: 1px solid #f4d0d9;
  }
  .icon-guanbi1{
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/gileadSales/nsd.vue